const productSwiperOptions = {
  slidesPerView: 1.1,
  spaceBetween: 16,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
  },
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 451px
    451: {
      slidesPerView: 2.2
    },
    // when window width is >= 551px
    551: {
      slidesPerView: 2.7
    },
    // when window width is >= 751px
    751: {
      slidesPerView: 3.2
    },
    // when window width is >= 991px
    991: {
      slidesPerView: 3.7
    },
    // when window width is >= 1251px
    1251: {
      slidesPerView: 4.2
    },
    // when window width is >= 1441px
    1441: {
      slidesPerView: 4.7
    },
  }
};

const mobileTabsSwiperOptions = {
  slidesPerView: 'auto',
  spaceBetween: 2,
  loop: false
};

const hideInactiveSwiperElementsOnLoad = (elementList) => {
  elementList.forEach((element) => {
    element.classList.remove('active');
  });
  if(elementList.length) {
    elementList[0].classList.add('active');
  }
};

const deactivateSwiperElements = (swiperElementsList, activeElement, multipleActiveElements = false) => {
  swiperElementsList.forEach((element) => {
    element.classList.remove('active');
  });
  if(multipleActiveElements) {
    activeElement.forEach((element) => {
      element.classList.add('active');
    });
  } else {
    activeElement.classList.add('active');
  }
}

const initSwipers = (productSwiperWrappersList) => {
  productSwiperWrappersList.forEach((collectionSwiper) => {
    const collectionSwiperId = collectionSwiper.getAttribute('id');
    const featuredCollectionSlider = new Swiper(`#${collectionSwiperId} .featuredCollectionSlider`, productSwiperOptions);
  });

  const mobileTabsSwiper = new Swiper('.mobileTabsSwiper', mobileTabsSwiperOptions);
};

window.addEventListener('load', () => {
  const customFeaturedCollections = document.querySelectorAll('.custom-featured-collection:not(.initialized)');

  customFeaturedCollections.forEach((customFeaturedCollection) => {
    const changeTabBtns = customFeaturedCollection.querySelectorAll('.desktop-collection-type-wrapper .collection-type');
    const mobileChangeTabBtns = customFeaturedCollection.querySelectorAll('.mobile-collection-type-wrapper .collection-type');
    const collectionSwipers = customFeaturedCollection.querySelectorAll('.collection-swiper');
    const collectionTitles = customFeaturedCollection.querySelectorAll('.collection-title');
    const allChangeTabBtns = [...changeTabBtns, ...mobileChangeTabBtns];

    initSwipers(collectionSwipers);

    hideInactiveSwiperElementsOnLoad(collectionSwipers);
    hideInactiveSwiperElementsOnLoad(collectionTitles);
    hideInactiveSwiperElementsOnLoad(changeTabBtns);
    hideInactiveSwiperElementsOnLoad(mobileChangeTabBtns);

    allChangeTabBtns.forEach((changeTabBtn) => {
      changeTabBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if(!changeTabBtn.classList.contains('active')) {
          const activeCollectionType = changeTabBtn.getAttribute('data-category');

          const activeCollectionSwiper = customFeaturedCollection.querySelector(`.collection-swiper[data-category="${activeCollectionType}"]`);
          const activeCollectionTitle = customFeaturedCollection.querySelector(`.collection-title[data-category="${activeCollectionType}"]`);
          const activeChangeTabBtns = customFeaturedCollection.querySelectorAll(`.collection-type[data-category="${activeCollectionType}"]`);

          deactivateSwiperElements(allChangeTabBtns, activeChangeTabBtns, true);
          deactivateSwiperElements(collectionSwipers, activeCollectionSwiper);
          deactivateSwiperElements(collectionTitles, activeCollectionTitle);
        }
      });
    });

    customFeaturedCollection.classList.add('initialized');
  });

});